import { Injectable } from '@angular/core';
import Echo from 'laravel-echo';
import { environment } from '../../environment/environment';

@Injectable({
  providedIn: 'root'
})
export class SocketService {

  public echo = new Echo({
    broadcaster: 'pusher',
    cluster: 'mt1',
    key: environment.socket.key,
    wsHost: environment.socket.wsHost,
    wsPort: environment.socket.wsPort,
    wssHost: environment.socket.wssHost,
    wssPort: environment.socket.wssPort,
    enabledTransports: ['ws', 'wss'],
    forceTLS: environment.socket.forceTLS
  });

}
